import React from "react";

type ContextMenuActionProps = {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  tone?: "default" | "success" | "danger";
  disabled?: boolean;
  selected?: boolean;
  type?: "button" | "submit";
  hoverText?: "dark" | "heading";
};

const toneClassMap: Record<NonNullable<ContextMenuActionProps["tone"]>, string> =
  {
    default: "text-heading",
    success: "text-state-success hover:bg-background-success hover:text-light focus-visible:bg-background-success focus-visible:text-light",
    danger: "text-state-error hover:bg-background-error hover:text-light focus-visible:bg-background-error focus-visible:text-light",
  };

const ContextMenuAction: React.FC<ContextMenuActionProps> = ({
  children,
  onClick,
  className = "",
  tone = "default",
  disabled = false,
  selected = false,
  type = "button",
  hoverText = "dark",
}) => {
  const defaultHoverTextClassName = hoverText === "heading"
    ? "hover:text-heading focus-visible:text-heading"
    : "hover:text-dark focus-visible:text-dark";
  const hoverClassName = tone === "default"
    ? `hover:bg-button-primary focus-visible:bg-button-primary ${defaultHoverTextClassName}`
    : "";
  const selectedClassName = selected
    ? tone === "default"
      ? "ui-action-button-active bg-[var(--color-button-primary)] text-dark"
      : tone === "danger"
        ? "bg-background-error text-light"
        : "ui-action-button-active bg-[var(--color-button-primary)] text-dark"
    : "";

  return (
    <button
      type={type}
      role="menuitem"
      aria-selected={selected}
      className={`ui-action-button box-border flex w-full items-start justify-end gap-[8px] rounded-[6px] p-[8px] text-right text-sm leading-5 whitespace-nowrap disabled:cursor-not-allowed disabled:text-disabled ${hoverClassName} ${toneClassMap[tone]} ${selectedClassName} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default ContextMenuAction;
